export * as common  from './common-function'
//export {common}